import { PublicClientApplication } from '@azure/msal-browser';
import { configuration } from './msalConfig';

export default new PublicClientApplication(configuration);
